export default "__VITE_ASSET__534944ca__"